/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One event volume bucket
 */
export type EventVolumeBucket = {
  /**
   * Bucket start in Unix nanoseconds (string for JS int64 precision)
   */
  bucketTimeUnixNano: string;
  /**
   * Log records in this bucket
   */
  logCount: number;
  /**
   * Spans in this bucket
   */
  spanCount: number;
};

/** @internal */
export const EventVolumeBucket$inboundSchema: z.ZodMiniType<
  EventVolumeBucket,
  unknown
> = z.pipe(
  z.object({
    bucket_time_unix_nano: z.string(),
    log_count: z.int(),
    span_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bucket_time_unix_nano": "bucketTimeUnixNano",
      "log_count": "logCount",
      "span_count": "spanCount",
    });
  }),
);

export function eventVolumeBucketFromJSON(
  jsonString: string,
): SafeParseResult<EventVolumeBucket, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EventVolumeBucket$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EventVolumeBucket' from JSON`,
  );
}
